import { render, staticRenderFns } from "./ITextarea.vue?vue&type=template&id=ef5bc254"
import script from "./ITextarea.vue?vue&type=script&lang=js"
export * from "./ITextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports